<template>
  <div>
    <div style="padding:5px 10px;font-size:13px;">{{$t('MODULE.I0011_LBL_TITLE')}}</div>
    <el-row style="margin-bottom:15px">
      <!-- 嘱託社員就業規則、ハラスメント防止規程、育児・介護休業等に関する規則 -->
      <el-col align="center" :span="24">
        <el-button style="width:95%" :class="[{i0011_afterClick:btn1},{i0011_button:!btn1}]" @click="btnClick('btn1')" v-html="$t('MODULE.I0011_LBL_BTN1')" type="primary">
        </el-button>
      </el-col>
    </el-row>
    <el-row style="margin-bottom:15px">
      <!-- 個人情報の取扱いに関する告知 -->
      <el-col align="center" :span="12">
        <el-button :class="[{i0011_afterClick:btn2},{i0011_button:!btn2}]" @click="btnClick('btn2')" v-html="$t('MODULE.I0011_LBL_BTN2')" type="primary"></el-button>
      </el-col>
      <!-- 給与支払方法に付いての明示 -->
      <el-col align="center" :span="12">
        <el-button :class="[{i0011_afterClick:btn3},{i0011_button:!btn3}]" @click="btnClick('btn3')" v-html="$t('MODULE.I0011_LBL_BTN4')" type="primary"></el-button>
      </el-col>
    </el-row>
    <el-row style="margin-bottom:10px">
      <!-- 雇用契約書の電磁的交付による明示 -->
      <el-col align="center" :span="12">
        <el-button :class="[{i0011_afterClick:btn4},{i0011_button:!btn4}]" @click="btnClick('btn4')" v-html="$t('MODULE.I0011_LBL_BTN5')" type="primary"></el-button>
      </el-col>
      <!-- 給与明細等の電磁的交付による明示 -->
      <el-col align="center" :span="12">
        <el-button :class="[{i0011_afterClick:btn5},{i0011_button:!btn5}]" @click="btnClick('btn5')" v-html="$t('MODULE.I0011_LBL_BTN6')" type="primary"></el-button>
      </el-col>
    </el-row>
    <!-- 上記内容に同意します -->
    <el-checkbox class="i0011_checkbox" :disabled="disabled" v-model="checked" style="margin-left:10px;">{{$t('MODULE.I0011_LBL_CONSENT')}}</el-checkbox>
    <div>
      <el-row style="text-align:center;padding-top: 10px;">
        <el-button class="css-btn css-button" style="width:140px" type="primary" :disabled="!checked" @click="applyBtnClick">{{$t('MODULE.I0011_LBL_APPLY')}}</el-button>
        <el-button class="css-btn css-button" type="primary" :disabled="menuOpenShow" 　@click="back">{{$t('COMMON.BTN_BACK')}}</el-button>
      </el-row>
    </div>

    <el-dialog fullscreen :visible.sync="viewVisible" :close-on-click-modal="false" :show-close="false" width="100%" top="52px" height="120%">
      <Pdf :src="pdfUrl" @pdfClose="pdfClose"></Pdf>
    </el-dialog>
  </div>
</template>

<script>
import utilApi from '@/common/utils'
import css from "@/statics/css"
import * as amsApi from "../api/i_0011"
import pdf from '@/components/page/pdf'
let url = require('@/../config/sysConfig')
import * as menuApi from "@/components/api/home"
export default {
  mixins: [css],
  components: {
    Pdf: pdf
  },
  data() {
    return {
      checked: false,
      disabled: true,
      btn1: false,
      btn2: false,
      btn3: false,
      btn4: false,
      btn5: false,
      //就業規則フラグ
      btn1Flag: '0',
      //個人情報告知フラグ
      btn2Flag: '0',
      //支払明示フラグ
      btn3Flag: '0',
      //雇用電磁フラグ
      btn4Flag: '0',
      //給与電磁フラグ
      btn5Flag: '0',
      //契約締結可能フラグ
      totalFlag: '0',
      //処理区分
      processCd: '',
      //pdfFlag
      viewVisible: false,
      pdfUrl: '',
      pdfPath: '',
      menuOpenShow: false,//是否可以按下菜单按钮
    };
  },
  methods: {
    //申請btn
    applyBtnClick() {
      this.$router.push({ path: url.routerUrl_C0001 })
    },
    btnClick(btn) {
      this[btn + 'Flag'] = '1'
      this.popMethod(btn)
      this.readFlagUpdate()
      this.handleMenuState()
    },
    //获取menu状态
    handleMenuState() {
      menuApi.menuStateManager(this.userInfo.userCd).then(res => {
        if (res.code == 204) {
          let menuState = res.items.menuState[0]
          localStorage.setItem("menuState", JSON.stringify(menuState))
          //
          if (menuState.i0011Used == '0' && menuState.c0001Expired == '1') {
            this.menuOpenShow = false
          } else {
            this.menuOpenShow = true
          }
        }
      })
    },
    //pop
    popMethod(btn) {
      if (btn == 'btn1') {
        this.pdfPath = url.routerUrl_I0011_btn1URL
      }
      if (btn == 'btn2') {
        this.pdfPath = url.routerUrl_I0011_btn2URL
      }
      if (btn == 'btn3') {
        this.pdfPath = url.routerUrl_I0011_btn3URL
      }
      if (btn == 'btn4') {
        this.pdfPath = url.routerUrl_I0011_btn4URL
      }
      if (btn == 'btn5') {
        this.pdfPath = url.routerUrl_I0011_btn5URL
      }
      this.set_loading()
      amsApi.PDFFile_get(this.pdfPath).then(res_file => {
        let fileUrl = {}
        let blob = new Blob([res_file], { type: 'application/octet-stream;charset=UTF-8' })
        let url = window.URL.createObjectURL(blob)
        fileUrl.url = url
        fileUrl.name = this.pdfPath
        for (let index = 0; index < 2; index++) {
          fileUrl.name = fileUrl.name.substring(fileUrl.name.indexOf('/') + 1)
        }
        this.download(fileUrl)
        this.close_loading()
      }).catch((err) => {
        //关闭loading
        this.close_loading()
      });
    },
    pdfClose() {
      this.viewVisible = false
    },
    //pdfダウンロード
    download(file) {
      this.pdfUrl = file
      this.viewVisible = true
    },
    //誓約・同意既読フラグ検索
    readFlagSearch() {

      amsApi.readFlagSearch(this.userInfo.userCd).then(res => {
        if (res.code == '204') {
          if (res.items.readFlag[0].processCd == '2') {
            this.processCd = res.items.readFlag[0].processCd
          } else if (res.items.readFlag[0].processCd == '1') {
            this.btn1Flag = res.items.readFlag[0].workRulesFlag
            this.btn2Flag = res.items.readFlag[0].personalInfoFlag
            this.btn3Flag = res.items.readFlag[0].paymentExplicateFlag
            this.btn4Flag = res.items.readFlag[0].employmentEmFlag
            this.btn5Flag = res.items.readFlag[0].salaryEmFlag
            this.totalFlag = res.items.readFlag[0].contractPossibleFlag
            this.processCd = res.items.readFlag[0].processCd
          }
          this.btnInit()
        } else if (res.code == '300') {
          //検索結果0件
          this.processCd = '2'
          this.$message.warning({ message: this.$t('COMMON.NO_TARGET_DATA'), showClose: true })
        }
      });
    },
    //誓約・同意既読フラグ更新
    readFlagUpdate() {
      if (this.btn2Flag == '1' && this.btn3Flag == '1' && this.btn4Flag == '1' && this.btn5Flag == '1') {
        this.$store.commit('increment', '0')
        this.totalFlag = '1'
      }
      var updateParam = [{
        "userId": this.userInfo.userCd,
        "workRulesFlag": this.btn1Flag,
        "personalInfoFlag": this.btn2Flag,
        "paymentExplicateFlag": this.btn3Flag,
        "employmentEmFlag": this.btn4Flag,
        "salaryEmFlag": this.btn5Flag,
        "contractPossibleFlag": this.totalFlag,
        "processCd": this.processCd
      }]
      amsApi.readFlagUpdate(updateParam).then(res => {
        if (res.code == '202') {
          this.readFlagSearch()
        } else if (res.code == '311') {
          this.$message.error({ message: this.$t('COMMON.CURD_ERROR'), showClose: true });//保存失敗
        }
      });
    },
    //btn初期化
    btnInit() {
      for (let index = 1; index <= 5; index++) {
        if (this['btn' + index + 'Flag'] == '1') {
          this['btn' + index] = true
        }
      }

      if (this.totalFlag == '1') {
        this.$store.commit('increment', '0')
        this.disabled = false
      } else {
        this.$store.commit('increment', '1')
      }
      this.handleMenuState()
    },

    back() {
      amsApi.noticeDetailSearch(this.userInfo.userCd).then(res => {
        if (res.code == '204') {
          for (var item of res.items.tNoticeDetail) {
            //未読のを知らせがある場合、お知らせ一覧画面へ遷移する
            if (item.confirmFlag == 0) {
              this.$router.push({ path: url.routerUrl_B0001 })
              return
            } else {
              //未読のお知らせがない場合、スケジュール画面へ遷移する
              this.$router.push({ path: url.routerUrl_S0001 })
            }
          }
        } else if (res.code == '300') {
          //お知らせがない場合、スケジュール画面へ遷移する
          this.$router.push({ path: url.routerUrl_S0001 })
        }
      });
    },
  },
  created() {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
    //誓約・同意既読フラグ検索
    this.readFlagSearch()
  },
};
</script>
<style >
.i0011_button {
  width: 90%;
  height: 100px;
  padding: 0px;
  color: #ffffff;
  font-size: 11pt;
  border-color: orange;
  background-image: linear-gradient(#f4b183, #f59a11);
}
.i0011_afterClick {
  width: 90%;
  height: 100px;
  padding: 0px;
  background-image: linear-gradient(#3cc6fa, #1197ca);
  color: #ffffff;
  font-size: 11pt;
}

.i0011_button:active,
.i0011_button:focus,
.i0011_button:hover {
  background-image: linear-gradient(#f4b183, #f59a11);
  border-color: orange;
}
.i0011_afterClick:active,
.i0011_afterClick:focus,
.i0011_afterClick:hover {
  background-image: linear-gradient(0deg, #0f91c2, #41bae6);
}
.i0011_checkbox .el-checkbox__label {
  font-size: 13px;
}
</style>


// WEBPACK FOOTER //
// src/module/page/i_0011.vue